/** Responsibility: read and mutate the watchlist. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { hubApi } from '../client';
import type { WatchCreate, WatchInput, WatchPatch } from '../client';

export function useWatches() {
  return useQuery({ queryKey: ['watches'], queryFn: hubApi.listWatches });
}

export function useCreateWatch() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (payload: WatchCreate) => hubApi.createWatch(payload),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['watches'] });
      // A product can name a list no channel sends yet; the Alerts picker
      // should offer it immediately rather than after a reload.
      client.invalidateQueries({ queryKey: ['notify-lists'] });
    },
  });
}

export function usePatchWatch() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ watchId, patch }: { watchId: string; patch: WatchPatch }) =>
      hubApi.patchWatch(watchId, patch),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['watches'] });
      client.invalidateQueries({ queryKey: ['notify-lists'] });
    },
  });
}

export function useUpsertWatch() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (watch: WatchInput) => hubApi.upsertWatch(watch),
    onSuccess: () => client.invalidateQueries({ queryKey: ['watches'] }),
  });
}

export function useDeleteWatch() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (watchId: string) => hubApi.deleteWatch(watchId),
    onSuccess: () => client.invalidateQueries({ queryKey: ['watches'] }),
  });
}
